var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5H5a1.655 1.655 0 01-1.533-1.017L.95 10.608A1.646 1.646 0 01.833 10V8.333c0-.916.75-1.666 1.667-1.666h5.258l-.791-3.809-.025-.266c0-.342.141-.659.366-.884l.884-.875 5.491 5.492c.3.3.484.717.484 1.175v8.333c0 .917-.75 1.667-1.667 1.667zm3.333 0v-10h3.334v10h-3.334z",
    fillRule: "nonzero"
  })));
}
export default SvgThumbUp;